import { QtmButton } from '@qtm/react';
import UsageLogItem from 'modules/Users/userStats/UsageLogItem';
import { useState } from 'react';
import { UsageLog } from 'shared/model/usageLog.model';

type Props = {
  logs: UsageLog[];
};

const ShowRowLogs = ({ logs }: Props) => {
  const [show, setShow] = useState(false);

  const toggle = () => {
    setShow(!show);
  };

  const btnText = show ? 'Hide Raw Logs' : 'Show Raw Logs';

  return (
    <div>
      <div className="mb-m">
        <QtmButton variant="filled" color="primary" onClick={toggle}>
          {btnText}
        </QtmButton>
      </div>
      {show && (
        <div>
          {logs.map(log => (
            <UsageLogItem key={log.id} item={log} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ShowRowLogs;
